import { createSlice } from "@reduxjs/toolkit"
import { apiSlice } from "./apiSlice";

import type { ISystemPlotSlice } from "../../interfaces/interfaces";

const initialState: ISystemPlotSlice = {
	requiredSubscriptionLevel: 'free'
}

const systemPlotSlice = createSlice({
	name: "systemPlotSlice",
	initialState,
	selectors: {
	},
	reducers: {
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(apiSlice.endpoints.calculator.matchFulfilled, (state, action) => {
				const params = action.meta.arg.originalArgs as Record<string, string>;
				if (!params?.calculator_type) {
					console.warn("No calculator_type in calculator response");
					return;
				}

				if (params.calculator_type != "system_plot") {
					return;
				}

				if (action.payload && params.well == "well1") {
					state.result1 = action.payload.results;
					state.chartsData1 = action.payload.plots;
				}

				if (action.payload && params.well == "well2") {
					state.result2 = action.payload.results;
					state.chartsData2 = action.payload.plots;
				}
			})
	}
})

export default systemPlotSlice

export const {
} = systemPlotSlice.actions